import React from 'react';
interface SectionProps {
  id?: string;
  tone?: 'dark' | 'darker' | 'light';
  children: React.ReactNode;
}
const tones: Record<NonNullable<SectionProps['tone']>, string> = {
  dark: 'bg-navy-900 text-white',
  darker: 'bg-navy-950 text-white',
  light: 'bg-slate-50 text-navy-950'
};
export function Section({
  id,
  tone = 'darker',
  children
}: SectionProps) {
  return <section id={id} className={`w-full px-4 py-14 sm:px-6 sm:py-20 ${tones[tone]}`} data-id="element-51" data-mp="cfojvlszoufw">
      <div className="mx-auto w-full max-w-5xl" data-id="element-52" data-mp="ci0zvtf6suqb">{children}</div>
    </section>;
}
interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  invert?: boolean;
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  invert
}: SectionHeadingProps) {
  return <header className="mx-auto max-w-3xl text-center" data-id="element-53" data-mp="vej254rnwd0t">
      {eyebrow ? <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-gold-500 sm:text-xs" data-id="element-54" data-mp="vcfznl9borf7">
          {eyebrow}
        </p> : null}
      <h2 className={`mt-3 font-display text-[26px] font-bold leading-[1.15] sm:text-4xl ${invert ? 'text-navy-950' : 'text-white'}`} data-id="element-55" data-mp="2zk24hnwun4ee">
        {title}
      </h2>
      <div className="gold-rule mx-auto mt-5 h-px w-28" data-id="element-56" data-mp="38dfb1snu64iy" />
      {subtitle ? <p className={`mt-5 text-[15px] leading-relaxed sm:text-lg ${invert ? 'text-slate-600' : 'text-slate-300'}`} data-id="element-57" data-mp="33m6w6h3qlqye">
          {subtitle}
        </p> : null}
    </header>;
}